/**
 * The whole family, drawn where a child's face would be (2026-10-13): the
 * family icon in a ringed circle, for family-pot money, family entries and
 * goals the whole family is saving for. Decorative -- the words beside it
 * always say "Family pot" or "whole family".
 */
import { NAV_ICONS } from '../brand/navIcons';

export function FamilyMark({ size = 36, className }: { size?: number; className?: string }) {
  return (
    <span
      className={className ? `family-mark ${className}` : 'family-mark'}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 24 24"
        width={Math.round(size * 0.56)}
        height={Math.round(size * 0.56)}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        dangerouslySetInnerHTML={{ __html: NAV_ICONS.family }}
      />
    </span>
  );
}
